import React from 'react'
import {Link} from 'gatsby'
import Img from 'gatsby-image'
import Card from 'react-bootstrap/Card'



const PostLink = ({post}) => (
    
        <Card style={{ width: '100%' }} bg="dark" className='my-5'>
        <Link to={post.frontmatter.slug}><Img className="card-image-top" fluid= {post.frontmatter.featuredImage.childImageSharp.fluid} /></Link>
        <Card.Body>
        <Link to={post.frontmatter.slug}><Card.Title><h2>{post.frontmatter.title}</h2></Card.Title></Link>   
             <Card.Text>{post.frontmatter.date}</Card.Text>
         </Card.Body>
        </Card>        
        
)

export default PostLink